module.exports = __webpack_public_path__ + "assets/img/free_21.ea19a806.png";